import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { confirm } = Modal;

const SaveConfirmationModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  loading = false 
}) => {
  const { t } = useTranslation();

  React.useEffect(() => {
    if (open) {
      confirm({
        title: t('save_confirmation_message') || 'Bu formu kaydetmek istediğinize emin misiniz?',
        icon: <ExclamationCircleOutlined style={{ color: '#1976d2' }} />,
        okText: loading ? (t('saving_form') || 'Kaydediliyor...') : (t('save') || 'Kaydet'),
        cancelText: t('cancel') || 'İptal',
        okButtonProps: {
          loading: loading,
          disabled: loading
        },
        onOk: () => {
          onConfirm();
        },
        onCancel: () => {
          if (!loading) {
            onClose();
          }
        },
        closable: !loading,
        maskClosable: !loading
      });
    }
  }, [open, loading, onConfirm, onClose, t]);

  return null;
};

export default SaveConfirmationModal;
